const defaultSelectors = {
  accordionSection: "[data-acc-section]",
  accordionButton: "[data-acc-button]",
  accordionTitle: "[data-acc-title]",
  accordionContent: "[data-acc-content]",
};

type Selectors = typeof defaultSelectors;

export class FreemarkerAccordions {
  selectors: Selectors;

  constructor() {
    this.selectors = defaultSelectors;

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => {
        this.initializeAccordions();
      });
    } else {
      this.initializeAccordions();
    }
  }

  addClickListener(accordion: HTMLElement) {
    accordion.addEventListener("click", (event) => {
      const htmlTarget = event.target as HTMLElement;

      const isInContent = htmlTarget
        ? !!htmlTarget.closest(this.selectors.accordionContent)
        : false;
      if (!isInContent) {
        this.toggleAccordion(accordion);
      }
    });
  }

  addFocusInListener(accordion: HTMLElement) {
    if (!accordion.hasAttribute("data-focus-open")) {
      return;
    }

    const content = accordion.querySelector(this.selectors.accordionContent);

    if (!content) {
      return;
    }

    accordion.addEventListener("focusin", (e) => {
      if (e.target instanceof Node && content.contains(e.target)) {
        accordion.setAttribute("data-open", "true");
      }
    });
  }

  toggleAccordion(accordion: HTMLElement) {
    const isOpen = accordion.getAttribute("data-open") === "true";
    accordion.setAttribute("data-open", isOpen ? "false" : "true");
  }

  accTitleFocusListener(accordion: HTMLElement) {
    const headline: HTMLHeadElement | null = accordion.querySelector(
      this.selectors.accordionButton,
    );

    if (!headline) {
      console.error("No headline found in accordion", accordion);
      return;
    }

    headline.addEventListener("focus", () => {
      if (!accordion) return console.info("accordion not found.");
      accordion?.setAttribute("data-focused", "true");
    });

    headline.addEventListener("blur", () => {
      accordion?.setAttribute("data-focused", "false");
    });
  }

  addIdToAccordion(accordion: HTMLElement) {
    const button: HTMLElement | null = accordion.querySelector(
      this.selectors.accordionButton,
    );

    if (!button || !accordion)
      return console.error("Accordion or Button is missing");

    const id = this.generateId();
    accordion.setAttribute("id", id);
    button.setAttribute("aria-controls", id);
  }

  jumpToProductDetailsLinkClickHandler(
    event: Event,
    accordion: HTMLElement | undefined,
  ) {
    if (!accordion) {
      console.warn("No Accordion found");
      return;
    }

    this.toggleAccordion(accordion);
  }

  private getAllAccordions(): HTMLElement[] {
    return Array.from(
      document.querySelectorAll(this.selectors.accordionSection),
    );
  }

  private initializeAccordions() {
    const accordions = this.getAllAccordions();
    const jumpToProductDetailsLink = document.querySelector(
      "#pda-anker-to-productdescription-section",
    );
    if (accordions.length === 0) {
      return;
    }

    for (const acc of accordions) {
      this.addClickListener(acc);
      this.addFocusInListener(acc);
      this.accTitleFocusListener(acc);
      this.addIdToAccordion(acc);
    }

    if (jumpToProductDetailsLink && accordions && accordions.length > 0) {
      jumpToProductDetailsLink.addEventListener("click", (event) =>
        this.jumpToProductDetailsLinkClickHandler(event, accordions[0]),
      );
    }
  }

  private generateId(): string {
    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const length = 7;
    return `accordion-${Array.from(
      { length },
      () => letters[Math.floor(Math.random() * letters.length)],
    ).join("")}`;
  }
}

new FreemarkerAccordions();
